<div class="container-fluid max-width fault-item" [class.fault-item-selected]="fault?.isSelected" (click)="changeCheck()">
    <!-- <div [style.overflow]="'hidden'" class="row" [class.fixed-height]="hideDetails">
      <div *ngIf="fault.attachmentUrl" class="col-xs-2 col-md-2" [style.height.px]="150">
        <img [src]="fault.attachmentUrl" style="display: block;width: 100%;height: 90%; margin-top:1%; object-fit: cover;">
        <input type="checkbox"  [checked]="fault?.isSelected" (change)="changeCheck()" (click)="$event.stopPropagation();" [hidden]="!!fault?.newStatus || !fault.IsEditable"
        [style.position]="'absolute'" [style.top]="'0px'" />
      </div>
      <div *ngIf="!fault.attachmentUrl" class="col-xs-2 col-md-2" [style.background]="'url(../../../assets/no_image.png)'" [style.height.px]="150"
        [style.backgroundSize]="'cover'" [style.backgroundRepeat]="'no-repeat'" [style.backgroundPosition]="'50% 50%'" [style.backgroundOrigin]="'padding-box'">
        <input type="checkbox"  [checked]="fault?.isSelected" (change)="changeCheck()" (click)="$event.stopPropagation();" [hidden]="!!fault?.newStatus || !fault.IsEditable"/>
      </div>

      <div class="col-xs-6 col-md-6" style="overflow-x: hidden; overflow-y: auto; white-space:nowrap;">
        <div class="row header" [innerHTML]="header | highlight: fault.search"></div>
        <ng-container *ngFor="let field of layout.viewProperties; let i=index">
          <ng-container *ngIf="i<2">
            <div class="row top-buffer">
              <div class="col-xs-3"  [style.fontSize]="'9px'"><b>{{field.Label}}:</b></div>
            </div>
            <div class="row top-buffer">
              <div class="col-xs-9" [style.fontSize]="'12px'">
                <b [innerHTML]="getValueForProperty(field.FieldId) | format | highlight: fault.search"></b>

              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="i==2 && hideDetails">
            <div class="row top-more-buffer">
              <div class="col-xs-3"  [style.fontSize]="'9px'" [style.color]="'blue'">
                <b [style.color]="'blue'" [style.cursor]="'pointer'" (click)="$event.stopPropagation();toggleDetails();">mehr anzeigen...</b>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!hideDetails">
            <ng-container *ngFor="let field of layout.viewProperties; let i=index">
              <ng-container *ngIf="i>1">

                <div class="row top-buffer">
                  <div class="col-xs-3"  [style.fontSize]="'9px'"><b>{{field.Label}}:</b></div>
                </div>
                <div class="row top-buffer">
                  <div class="col-xs-9" [style.fontSize]="'12px'">
                      <b [innerHTML]="getValueForProperty(field.FieldId) | format | highlight: fault.search"></b>
                  </div>
                </div>
              </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!hideDetails">
            <div class="row top-more-buffer bottom-buffer">
              <div class="col-xs-3"  [style.fontSize]="'9px'" [style.color]="'blue'">
                <b [style.color]="'blue'" [style.cursor]="'pointer'" (click)="$event.stopPropagation();toggleDetails();">weniger anzeigen...</b>
              </div>
            </div>
        </ng-container>

      </div>

      <div class="col-xs-4 col-md-4">
        <div class="row header">Aktion:</div>
        <ng-container *ngIf="fault?.faultState===FaultState.cannotEdit||fault?.faultState===FaultState.mustUpload">
          <div class="row top-buffer">
            <div class="col-xs-3"  [style.fontSize]="'9px'"><b>Status:</b></div>
          </div>
          <div class="row top-buffer">
            <div class="col-xs-9" [style.fontSize]="'12px'">
                <span *ngIf="fault?.newStatus"><b>{{fault?.newStatus?.Name1}} - {{fault?.newStatus?.Name2}}</b></span>
                <span *ngIf="fault?.Activities?.length>0 && !fault?.newStatus">
                  <b>{{fault.Activities[0].Status.Name1}} - {{fault.Activities[0].Status.Name2}} (vom {{dateToLocalDate(fault.Activities[0].Date)}})</b>
                </span>
            </div>
          </div>
          <div class="row top-buffer">
            <div class="col-xs-3"  [style.fontSize]="'9px'"><b>Bemerkung:</b></div>
          </div>
          <div class="row top-buffer">
            <div class="col-xs-9" [style.fontSize]="'12px'">
                <span *ngIf="fault?.newStatus"><b>{{fault?.newText}}</b></span>
                <span *ngIf="fault?.Activities?.length>0 && !fault?.newStatus">
                  <b>{{fault.Activities[0].Description}}</b>
                </span>
            </div>
          </div>
          <div class="row top-buffer">
            <div class="col-xs-3"  [style.fontSize]="'9px'"><b>Datei:</b></div>
          </div>
          <div class="row top-buffer">
            <div class="col-xs-9" [style.fontSize]="'12px'">
              <span><b>{{fault?.newFile?.name}}</b></span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="fault?.faultState===FaultState.uploadingActivity">
          <div class="col-xs-12 text-center">
            <img [style.width]="'20px'" [style.height]="'20px'" src="../../../assets/loader1.gif" alt="">
            Vorgang anlegen...
          </div>
        </ng-container>
        <ng-container *ngIf="fault?.faultState===FaultState.uploadingAttachment">
          <div class="col-xs-12 text-center">
            <img [style.width]="'20px'" [style.height]="'20px'" src="../../../assets/loader1.gif" alt="">
            Datei Upload...
          </div>
        </ng-container>
        <ng-container *ngIf="fault?.faultState===FaultState.uploadErrorActivity">
          <div class="col-xs-12 text-center">
            <img src="../../../assets/error.png" alt="">
              Fehler beim Anlegen des Vorgangs
          </div>
        </ng-container>
        <ng-container *ngIf="fault?.faultState===FaultState.uploadErrorAttachment">
          <div class="col-xs-12 text-center">
            <img src="../../../assets/error.png" alt="">
            Fehler beim Upload der Datei
          </div>
        </ng-container>
        <ng-container *ngIf="fault?.faultState===FaultState.synced">
          <div class="col-xs-12 text-center">
            <img src="../../../assets/check.png" alt="">
          </div>
        </ng-container>
        <ng-container *ngIf="fault?.faultState===FaultState.canEdit">
          <div class="col-xs-12 text-center">
            <button class="btn btn-default" (click)="$event.stopPropagation();edit(fault);">
              <span class="glyphicon glyphicon-flag"></span> Bearbeiten
            </button>
          </div>
        </ng-container>
      </div>
    </div> -->
  </div>
